import React from "react"
import { Container, Box, Grid } from "@mui/material"
import { makeStyles } from "makeStyles"
import { ProductAttributes } from "@secureo/common/typings/Product"

const useStyles = makeStyles()(() => ({
	info: {
		textTransform: "uppercase",
		opacity: 0.75,
		fontSize: 13,
		letterSpacing: 0.5,
		fontWeight: 100,
	},
	responsiveHeadline: {
		marginTop: 100,
		"@media only screen and (max-width: 960px)": {
			marginTop: 10,
		},
	},
}))

const Overview = ({ attributes, atAGlanceContent }: Props) => {
	const { classes } = useStyles()

	const {
		fireSafetyGrade,
		securityGrade,
		volumeLiter,
		weightKg,
		innerDepth,
		innerHeight,
		innerWidth,
		outerDepth,
		outerWidth,
		outerHeight,
		numberOfKeyHooks,
		numberOfShelves,
		anchoring,
		doorOpeningAngle,
		doorSwingDirection,
		positionOfHinges,
	} = attributes

	const details = [
		{
			name: "Sicherheitsstufe",
			attribute: securityGrade,
		},
		{
			name: "Brandschutz",
			attribute: fireSafetyGrade,
		},
		{
			name: "Gewicht",
			attribute: weightKg ? weightKg + " kg" : "",
		},
		{
			name: "Volumen",
			attribute: volumeLiter ? volumeLiter + " Liter" : null,
		},
		{
			name: "Außenmaße",
			attribute: `H${outerHeight} x B${outerWidth} x T${outerDepth}`,
		},
		{
			name: "Innenmaße",
			attribute: `H${innerHeight} x B${innerWidth} x T${innerDepth}`,
		},
		{
			name: "Anz. Fachböden",
			attribute: numberOfShelves,
		},
		{
			name: "Anz. Schlüsselhaken",
			attribute: numberOfKeyHooks,
		},
		{
			name: "Türanschlag",
			attribute: doorSwingDirection?.replace("right", "rechts")?.replace("left", "links"),
		},
		{
			name: "Türöffnungswinkel",
			attribute: doorOpeningAngle ? doorOpeningAngle + " °" : null,
		},
		{
			name: "Verankerung",
			attribute: anchoring,
		},
		{
			name: "Scharniere",
			attribute: positionOfHinges
				? positionOfHinges.replace("outside", "Außen").replace("inside", "Innen")
				: null,
		},
	]

	return (
		<Container style={{ marginTop: 50 }} id="specifications">
			<Grid container spacing={3}>
				<Grid item xs={12} md={7}>
					<div
						dangerouslySetInnerHTML={{
							__html: atAGlanceContent,
						}}
						style={{ marginTop: 40, lineHeight: 2 }}
					/>
				</Grid>
				<Grid item xs={12} md={5}>
					<div
						style={{
							background: "rgba(255, 255, 255, 0.1)",
							width: "100%",
							borderRadius: 5,
							padding: "50px 30px",
						}}
					>
						<Grid container spacing={3}>
							{details
								.filter((detail) => Boolean(detail.attribute))
								.map((detail) => {
									return (
										<Grid item xs={12} sm={6} key={detail.name}>
											<Box className={classes.info}>{detail.name}</Box>
											<Box mb={2}>
												<strong>{detail.attribute}</strong>
											</Box>
										</Grid>
									)
								})}
						</Grid>
					</div>
				</Grid>
			</Grid>
		</Container>
	)
}

interface Props {
	attributes: ProductAttributes
	atAGlanceContent: string
}

export default Overview
